import React, { useState } from "react";
import "./CollectionDescription.scss";

const CollectionDescription = ({ paragraphs = [] }) => {
  const [isVisible, setIsVisible] = useState(false);

  const safeParagraphs = Array.isArray(paragraphs)
    ? paragraphs
    : paragraphs
    ? [paragraphs]
    : [];

  return (
    <div className="collection-description-container">
      {!isVisible && (
        <button className="toggle-btn" onClick={() => setIsVisible(true)}>
          About
        </button>
      )}

      {isVisible && (
        <>
          <div className="collection-description">
            {safeParagraphs.map((p, index) => (
              <p key={index} className="cd-paragraph">
                {p}
              </p>
            ))}
          </div>

          <button
            className="toggle-btn bottom-btn"
            onClick={() => setIsVisible(false)}
          >
            Hide
          </button>
        </>
      )}
    </div>
  );
};

export default CollectionDescription;
